import http from '../APIs/olonaTeams'

export default class PostAPI {
    // poste
  public getSkillsByPoste = (id: string | number) => http.get(`/poste/${id}`)

  public getSousPoste = (id: string | number, etat: string | number) => http.get(`/sousposte/${id}/${etat}`)

  public getPostes = () => http.get(`/postes`)
}